// extracted by mini-css-extract-plugin
module.exports = {"LoopVideoSection":"LoopVideoSection_LoopVideoSection__K0zog"};